import { convertFirstColumnToRowHeaders } from './table-row-headers.js';

const wraptables = () => {
    const tables = Array.from(document.querySelectorAll('.content table'));
    tables.forEach((table, index) => {
        var _a;
        const caption = table.querySelector('caption');
        let captionId = (caption === null || caption === void 0 ? void 0 : caption.id) || '';
        if (caption && !captionId) {
            captionId = `rte-caption-${index}`;
            caption.id = captionId;
        }
        const wrapper = document.createElement('div');
        wrapper.className = 'table-wrapper';
        // Only promote to a labeled landmark when a caption id is available.
        // role="region" without an accessible name is an ARIA violation (WCAG 1.3.1).
        if (captionId) {
            wrapper.setAttribute('tabindex', '0');
            wrapper.setAttribute('role', 'region');
            wrapper.setAttribute('aria-labelledby', captionId);
        }
        convertFirstColumnToRowHeaders(table);
        (_a = table.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
};
document.addEventListener('DOMContentLoaded', wraptables);

export { wraptables };
